"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeritageExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const stats = [{
    value: "15+",
    label: "Years Experience"
  }, {
    value: "100%",
    label: "Health Tested"
  }, {
    value: "Champion",
    label: "Bloodlines"
  }, {
    value: "Lifetime",
    label: "Support"
  }];
  return <section id="heritage-excellence" className="dark bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-secondary/10 pointer-events-none"></div>

      {}
      <div className="absolute inset-0 opacity-5 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/mile_high_cavaliers_crest_watermark.png)] bg-center bg-no-repeat bg-[length:90%_auto] md:bg-[length:40%_auto] pointer-events-none"></div>

      <div ref={ref} className={`container mx-auto px-6 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 md:gap-8 text-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center space-y-4">
              <span className="font-sans text-5xl md:text-6xl font-bold text-primary tracking-tight">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-muted-foreground uppercase tracking-[0.2em] font-medium">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}